import React, { useMemo, useEffect } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { FaPhone, FaEnvelope, FaMapMarkerAlt, FaGlobe, FaInstagram, FaFacebookF, FaYoutube,} from "react-icons/fa";
import Logo from "../assets/sfsLogo2.png";

// cspell: ignore Srivilliputtur Thevar Tamilnadu loanvenuma Subramaniam noopener noreferrer

const Footer = () => {
  const location = useLocation();
  const navigate = useNavigate();
 useEffect(() => {
    const days = ['sunday', 'monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday'];
    const today = new Date().getDay();
    document.getElementById(days[today]).classList.add('text-[#1e4d91]', 'font-bold');
  }, []);
  const navItems = useMemo(
    () => [
      { type: "page", path: "/about-us", label: "About" },
      { type: "section", id: "loan", label: "Loan" },
      { type: "section", id: "why-choose-us", label: "Why Choose Us" },
      { type: "section", id: "our-services", label: "Our Services" },
      { type: "page", path: "/contact-us", label: "Contact" },
      { type: "page", path: "/privacy-policy", label: "Privacy Policy" },
    ],
    []
  );

  const scrollToSection = (id) => {
    const el = document.getElementById(id);
    if (el) {
      const yOffset = -100; // same header offset
      const y = el.getBoundingClientRect().top + window.pageYOffset + yOffset;
      window.scrollTo({ top: y, behavior: "smooth" });
    }
  };

  const handleFooterNavClick = (item) => {
    if (item.type === "section") {
      if (location.pathname !== "/") {
        navigate(`/#${item.id}`);
      } else {
        scrollToSection(item.id);
        window.history.replaceState(null, "", `#${item.id}`);
      }
    } else if (item.type === "page") {
      navigate(item.path);
    }
  };

  return (
    <footer className="bg-white text-gray-800 pt-12 pb-8 px-4 sm:px-6 lg:px-8 font-sans">
      <div className="container mx-auto rounded-3xl shadow-xl bg-gradient-to-t from-blue-50 to-white p-6 sm:p-8 lg:p-12">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-[23%_15%_30%_25%] xl:grid-cols-[30%_15%_30%_20%] gap-8">
        {/* <div className="grid gap-8 grid-cols-1 md:grid-cols-2 xl:grid-cols-[30%_15%_30%_20%]"> */}

          {/* Brand Info */}
          <div className="space-y-6">
            <div className="flex-shrink-0 flex items-center">
              <Link
                to="/"
                className="focus:outline-none focus:ring-2 focus:ring-[#1e4d91] rounded-lg"
              >
                <img
                  src={Logo}
                  alt="Subramaniam Financial Services"
                  className="cursor-pointer h-12 sm:h-14 md:h-16 w-auto transition-all duration-300 hover:scale-105"
                />
              </Link>
            </div>
            <p className="text-sm sm:text-base text-gray-600 leading-relaxed">
              Ready to elevate your financial journey? Contact us today to
              discuss your needs and discover how we can help you achieve your
              goals.
            </p>
            <div className="flex items-center space-x-2 group hover:text-[#1e4d91] transition">
              <FaGlobe />
              <a
                href="https://loanvenuma.com"
                target="_blank"
                rel="noopener noreferrer"
              >
                loanvenuma.com
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div className="space-y-4">
            <h3 className="text-lg sm:text-xl font-bold">Quick Links</h3>
            <ul className="">
              {navItems.map((item) => (
                <li key={item.label}>
                  <button
                    onClick={() => handleFooterNavClick(item)}
                    className="text-left text-gray-600 font-semibold hover:text-[#1e4d91] hover:font-bold transition text-sm sm:text-base block py-1 focus:outline-none"
                  >
                    {item.label}
                  </button>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact Info */}
          <div className="space-y-4">
            <h3 className="text-lg sm:text-xl font-bold">Contact Us</h3>
            <div className="space-y-3 sm:space-y-4">
              <div className="flex items-start space-x-2">
                <FaMapMarkerAlt className="mt-1 flex-shrink-0" />
                <address className="not-italic text-sm sm:text-base leading-snug">
                  1A/19/3 DHANYA NAGAR, MADAVARVALAGAM,
                  <br />
                  SRIVILLIPUTTUR-626125,
                  <br />
                  TAMILNADU, INDIA.
                </address>
              </div>
              <div className="flex items-center space-x-3 group hover:text-[#1e4d91] transition">
                <FaPhone className="rotate-90" />
                <a href="tel:8973739377">8973739377</a>
              </div>
              <div className="flex items-center space-x-3 group hover:text-[#1e4d91] transition">
                <FaEnvelope />
                <a
                  href="mailto:subramaniamfinancialservices@gmail.com"
                  className="text-xs sm:text-sm break-all"
                >
                  subramaniamfinancialservices@gmail.com
                </a>
              </div>
            </div>
          </div>
          <div className="space-y-2 break-words">
          {/* <div className="w-full md:w-1/2 p-2 text-center md:text-center"> */}
            <h3 className="text-lg sm:text-xl font-bold mb-4">Working Hours</h3>
            <p id="monday">Mon 09:30 am - 06:30 pm</p>
            <p id="tuesday">Tue 09:30 am - 06:30 pm</p>
            <p id="wednesday">Wed 09:30 am - 06:30 pm</p>
            <p id="thursday">Thu 09:30 am - 06:30 pm</p>
            <p id="friday">Fri 09:30 am - 06:30 pm</p>
            <p id="saturday">Sat 09:30 am - 06:30 pm</p>
            <p id="sunday">Sun Closed</p>
          </div>
        </div>

        {/* Social Media Links */}
        <div className="mt-8 sm:mt-12 flex justify-center space-x-4">
            <a
                href="https://www.instagram.com/loan_venuma?igsh=bHk5ajM5Y3hraGF0"
                target="_blank"
                rel="noopener noreferrer"
                className="
                text-gray-800
                transition duration-300 transform
                hover:-translate-y-1 hover:scale-110
                hover:text-[#E1306C]  /* Instagram pink */
                "
            >
                <FaInstagram className="text-2xl sm:text-3xl" />
            </a>

            <a
                href="https://www.facebook.com/share/1JHZmRL4Nh/"
                target="_blank"
                rel="noopener noreferrer"
                className="
                text-gray-800
                transition duration-300 transform
                hover:-translate-y-1 hover:scale-110
                hover:text-[#1877F2]  /* Facebook blue */
                "
            >
                <FaFacebookF className="text-2xl sm:text-3xl" />
            </a>

            <a
                href="https://youtube.com/@subramaniyam_financial_service?si=Kk1_Ch2HqRDCw9qW"
                target="_blank"
                rel="noopener noreferrer"
                className="
                text-gray-800
                transition duration-300 transform
                hover:-translate-y-1 hover:scale-110
                hover:text-[#FF0000]  /* YouTube red */
                "
            >
                <FaYoutube className="text-2xl sm:text-3xl" />
            </a>
        </div>

        {/* Copyright */}
        <div className="text-center mt-4 sm:mt-6">
          <p className="text-gray-800 text-xs sm:text-sm">
            © {new Date().getFullYear()} Subramaniam Financial Services. All
            rights reserved.
          </p>
          {/* <div className="mt-2 flex space-x-4 justify-center">
                <a href="/" className="text-gray-800 hover:text-[#1e4d91] transition text-sm underline">Privacy Policy</a>
                <a href="/" className="text-gray-800 hover:text-[#1e4d91] transition text-sm underline">Terms of Service</a>
            </div> */}
        </div>
      </div>
    </footer>
  );
};

export default Footer;
